import { z } from 'zod';

export const PhoneTypeSchema = z.enum([
  'HOME_MOBILE',
  'HOME_LANDLINE',
  'OFFICE_MOBILE',
  'OFFICE_LANDLINE',
]);
export type PhoneType = z.infer<typeof PhoneTypeSchema>;

export const PhoneSchema = z.object({
  id: z.string(),
  type: PhoneTypeSchema,
  phoneNumber: z.string(),
});
export type Phone = z.infer<typeof PhoneSchema>;
